export default __webpack_public_path__ + "static/media/Sign2.e6b9a6d9.png";